export const en = {
  // Upload step
  uploadTitle: 'Upload photos',
  uploadHint: 'Click or drag images here',
  uploadHintTouch: 'Tap to choose photos',
  uploadOr: 'or',
  takePhoto: 'Take Photo',
  yourPhotos: 'Your photos',
  photoLabel: 'Photo {n}',
  photoCount: '{n} photos',
  addPhoto: 'Add photo',
  continue: 'Continue',
  stepLabel: 'Step {current} of {total}',

  // Style step
  chooseStyle: 'Choose a design style',
  describeCustomStyle: 'Describe your custom style',
  uploadReferenceTitle: 'Upload a reference photo',
  uploadReferenceHint: 'AI will match its tone, materials, and overall mood — your room photo stays the same.',
  removeReference: 'Remove reference',
  cleanupOptionTidy: 'Tidy up',
  cleanupOptionTidyDesc: 'Keep furniture, remove clutter / trash / dishes / mess',
  cleanupOptionEmpty: 'Empty the room',
  cleanupOptionEmptyDesc: 'Remove all furniture and decor. Walls and floor stay',
  cleanupChooseOption: 'Choose how to clean',
  layoutOptionFlow: 'Better flow',
  layoutOptionFlowDesc: 'Improve traffic patterns and access — easier to move around',
  layoutOptionSpacious: 'More spacious',
  layoutOptionSpaciousDesc: 'Open up sightlines and reduce visual clutter — feels bigger',
  // 평면도 모드 (2.4.0)
  planChooseOption: 'What should we make from your floor plan?',
  planOption_3d: '3D floor plan',
  planOption_3dDesc: 'The whole home from above, furnished in a style',
  planOption_room: 'One room',
  planOption_roomDesc: 'Paint a room on the plan and see it at eye level',
  planOption_clean: 'Clean up the plan',
  planOption_cleanDesc: 'A sketch or blurry plan, redrawn neatly',
  planCleanKindTitle: 'Drawing type',
  planCleanKind_line: 'Black & white',
  planCleanKind_color: 'Colored plan',
  planStyleTitle: 'Style',
  planRoomTitle: 'Which room?',
  planRoomSignIn: 'Sign in to pick a room on your plan.',
  planRoomPaint: 'Paint the room on the plan',
  planRoomPicked: 'Room picked',
  planRoomRepaint: 'Paint again',
  planRoomClear: 'Clear',
  planRoomNamePlaceholder: 'Or type the room name (e.g. master bedroom)',
  planCropHint: 'Crop the photo to just the floor plan for a more accurate result.',
  planFirstOnly: 'Only the first photo is used as the floor plan.',
  planRoomPickTitle: 'Pick a room',
  planRoomPickHint: 'Paint over the room you want to see. A rough fill is enough.',
  planRoomPickDone: 'Use this room',
  planRoomNeedPick: 'Paint a room on the plan, or type its name.',
  errNotFloorplan: "This doesn't look like a floor plan. Upload a floor plan, or pick a style instead.",
  planRoomFrom: 'Room picked on the plan',
  planInputLabel: 'Floor plan',
  planOutput_plan_3d: '3D floor plan',
  planOutput_plan_room: 'Room view',
  planOutput_plan_clean: 'Clean plan',
  planOutput_plan_color: 'Colored plan',
  planRoomFromResult: 'See a room',
  planRoomMake: 'Make this room',
  planRoomMeta: '{n} credits · this room at eye level, same home',
  layoutChooseOption: 'Choose how to rearrange',
  creditEarnHint: 'Earn credits by signing in daily (+1) or inviting friends (+5 each).',
  languageHint: 'Used for design analysis too.',
  reuseStyle: '— Reuse a past style —',
  customPlaceholder: "Describe the interior style you want (e.g., 'cozy cabin with warm wood tones', 'futuristic minimalist with metallic accents')",
  customStylePublicHint: 'Custom style text may appear anonymously in the community. You can turn this off in Account settings.',
  communityRankTitle: 'Trending styles',
  communityPeople: '{n} people used',
  customStylesChip: 'Custom styles',
  galleryRecentBadge: 'Just used',
  timeJustNow: 'just now',
  timeAgoMin: '{n}m ago',
  timeAgoHour: '{n}h ago',
  communityViewAll: 'View all',
  galleryTitle: 'Trending styles',
  briefsLabel: 'News',
  briefTopupKicker: 'Credits',
  briefTopupTitle: 'Not enough credits for the next design',
  briefTopupLine: 'Free credits refill tomorrow. Need more now? Get a pack.',
  briefSeasonKicker: 'In season',
  briefSeasonTitle: '{name} is here',
  briefSeasonLine: 'A seasonal style — only for a few weeks.',
  briefInviteKicker: 'Invite',
  briefInviteTitle: 'Invite a friend — you both get +{n} credits',
  briefInviteLine: 'Share your link. Credits arrive when they sign up.',
  galleryEmpty: 'Nothing trending here yet — styles show up once people start using them.',
  galleryBuiltinTitle: 'Style ranking lately',
  galleryPopularCustom: 'Popular custom styles lately',
  galleryDiscoverTitle: 'Discover custom styles',
  galleryShuffle: 'Shuffle',
  galleryTranslate: 'Translate',
  galleryTranslating: 'Translating…',
  galleryOriginal: 'Show original',
  galleryLiveTab: 'Live',
  galleryLiveWaiting: 'Waiting for new styles…',
  galleryLiveTitle: 'Being used right now',
  galleryRecentCustom: 'Recent custom styles',
  galleryUse: 'Use this style',
  styleShareNotice: 'Custom style text may appear anonymously in the community.',
  styleShareNoticeSettings: 'Turn off in settings',
  styleShareNoticeOk: 'Got it',
  communityTopTitle: 'Popular custom styles',
  communityRecentTitle: 'Just used by others',
  communityUses: 'Used {n}×',
  communityDesigns: '{n} designs',
  communityDesignsOne: '{n} design',
  styleShareTitle: 'Share custom styles',
  styleShareDesc: 'Let others discover and try the custom style text you write. Your photos are never shared.',
  additionalRequests: 'Additional requests',
  optional: '(optional)',
  additionalPlaceholder: "Any specific additions for your {style} design? (e.g., 'add a wooden coffee table', 'use teal as accent color')",
  addAdditionalRequest: '+ Add specific requests',
  generateDesign: 'Generate Design',
  back: 'Back',

  // Generate step
  generatingOne: 'AI is generating your interior design…',
  generatingMany: 'AI is generating {n} consistent designs for your room…',
  generatingOneExterior: 'AI is generating your exterior redesign…',
  generatingManyExterior: 'AI is generating {n} consistent exterior renders…',
  generatingOneGarden: 'AI is generating your garden redesign…',
  generatingManyGarden: 'AI is generating {n} consistent garden renders…',
  generationFailed: 'Generation failed',
  tryAgain: 'Try Again',

  // Error messages
  errNoInternet: 'No internet connection. Please check your network and try again.',
  errTimeout: 'The AI took too long to respond. Please try again.',
  errTooMany: 'Too many requests. Please wait a moment and try again.',
  errNetwork: 'Network error. Please check your connection and try again.',
  errAI: 'The AI design service ran into an issue. Please try again.',
  errFileType: 'Unsupported file type. Please upload a JPEG, PNG, or WebP image.',
  errFileTooLarge: 'File is too large. Please upload an image under 20MB.',
  errPhotoRead: "Couldn't read that photo. Please try another one.",
  errCameraAccess: "Can't access the camera. Please allow camera access in Settings.",
  errCameraCapture: "Couldn't take the photo. Please try again.",
  errCaptionSave: "Couldn't save the caption. Please try again.",
  imageUnavailable: 'Image unavailable',
  designShareText: 'Check out this {style} design made with archelier',
  altPhoto: 'Photo {n}',
  altOriginal: 'Original {n}',
  altGenerated: 'Design {n}',
  errInvalidSpace: 'We could not read this as a space. Use a photo that shows a room — a wall and floor together, or a corner of the room.',
  pickAnotherPhoto: 'Pick another photo',
  errCustomStyle: 'Please describe your custom style.',
  errSignIn: 'Sign in failed. Please try again.',
  errInsufficientCredits: "You're out of credits. Come back tomorrow for your daily bonus.",
  // 1 credit = 1 generated image, so N photos cost N credits.
  creditCostHint: '{n} photos use {c} credits — {p} per photo.',
  errCreditsShort: 'This needs {need} credits and you have {have}. Remove a photo, or invite a friend for more.',

  // Credits
  credits: 'Credits',
  creditsOne: '{n} credit',
  creditsMany: '{n} credits',
  outOfCredits: "You're out of credits",
  creditModalTitle: 'Get more credits',
  creditModalDesc: 'Your daily credits refill tomorrow. Want more before then?',
  creditModalWallDesc: "That's today's free designs. {n} more come back tomorrow — or top up now and keep going.",
  errOutOfCreditsToday: "You're out of credits for today. {n} free designs come back tomorrow — or top up to keep going.",
  lastFreeHint: "That was today's last free design. {n} more tomorrow.",
  lastFreeHintCta: 'Top up now',
  creditModalChatFree: 'Chatting with Gio, your designer, stays free.',
  creditModalGuestTitle: 'Sign in to keep creating',
  creditModalGuestDesc: 'Signing in gets you free credits every day, plus saving and sharing.',
  creditOptionSignIn: 'Sign in and continue',
  creditOptionSignInDesc: 'Start in a second with Google or Apple',
  creditOptionInvite: 'Invite a friend',
  creditOptionInviteDesc: 'You both get +{n} credits when they sign up',
  comingSoon: 'Coming soon',
  close: 'Close',
  getAppTitle: 'archelier',
  getAppDesc: 'Redesign your own space in the app',
  getAppCta: 'Get',
  appGateTitle: 'Continue in the app',
  appGateDesc: 'Designing works best in the app — camera, saved designs and faster results.',
  appGateCta: 'Get the app',
  appGateNotNow: 'Not now',
  dailyBonusHint: 'You get {n} free credits every day.',
  creditsAria: '{n} credits left',
  accountCreditsTitle: 'Credits',
  creditsDailyLabel: 'Daily, resets at midnight',
  creditsBonusLabel: 'Bonus, never expires',
  creditsResetHint: 'You get {n} free credits every day. Bonus credits from invites stay until you use them.',
  creditsInviteCta: 'Invite a friend for +{n}',
  creditsTopUpCta: "Buy credits",
  inviteMenu: 'Invite friends',
  profileShare: 'Share',
  profileShareText: "Take a look at {name}'s designs on archelier.",

  // Result step
  original: 'Original',
  aiDesign: 'AI Design',
  imageGenFailed: 'Image generation failed for this photo',
  seeAnalysis: 'See the design analysis below.',
  analysisTitle: 'Interior Design Analysis',
  spaceAnalysis: 'Space Analysis',
  styleDescription: 'Style Description',
  colorPalette: 'Color Palette',
  furnitureRec: 'Furniture Recommendations',
  shopFor: 'Shop for {item}',
  shopShort: 'Shop',
  paintMatch: 'Closest paint',
  paintCodeCopy: 'Copy paint code',
  paintCodeCopied: 'Code copied',
  editRegion: 'Edit a part',
  editRegionTitle: 'Edit this design',
  editRegionDesc: 'Tell the AI what to change and what to put in its place. The rest of the room stays the same.',
  editRegionBrushHint: 'Tell the AI what to change or add. To change one spot, brush over it first — otherwise it edits the whole picture. To remove something, brush it and write “remove it”.',
  editRegionMeta: 'Saved as new design · {n} credits',
  editedFromBanner: 'This is an edited copy.',
  viewOriginal: 'View original',
  editsOfThisDesign: 'Edits of this design',
  editsOfThisDesignDesc: 'Designs you created by editing parts of this one.',
  chatTitle: 'AI design advisor',
  chatHint: 'Ask follow-up questions about this room. The AI sees your design and stays grounded in it.',
  chatStart: 'Start a conversation',
  chatPlaceholder: 'Ask about a piece, color, or layout idea…',
  chatSend: 'Send',
  chatSending: 'Thinking…',
  chatSuggestion1: 'What lamp would warm this room up?',
  chatSuggestion2: 'How can I make this feel more spacious?',
  chatSuggestion3: 'What 3 things should I change first?',
  chatTurnsRemaining: '{n} turns left on this design',
  chatTurnsExhausted: "You've reached the chat limit for this design. Start a new design to keep talking.",
  chatErrGeneric: "The advisor couldn't reply. Please try again.",
  chatPro: 'Pro — unlimited chat',
  chatRetry: 'Try again',
  commentsTitle: 'Comments',
  commentPlaceholder: 'Add a comment',
  commentPost: 'Post',
  commentPosting: 'Posting…',
  commentSignInHint: 'Sign in to leave a comment.',
  commentEmpty: 'No comments yet.',
  commentDelete: 'Delete',
  commentDeleteConfirm: 'Delete this comment?',
  commentTooLong: 'Comments are limited to 500 characters.',
  commentErrGeneric: "Couldn't post the comment. Please try again.",
  commentCount: '{n}',
  bookmarksTitle: 'My Collections',
  // MyTabs (Designs / Collections / Profile) sub-tab labels — already inside the
  // "My" hub so prefix is redundant. Instagram 식 Posts / Saved 도 같은 패턴.
  tabDesigns: 'Designs',
  tabCollections: 'Collections',
  bookmarksSectionTitle: 'Bookmarked designs',
  bookmarksEmpty: 'No collections yet. Save any design to start a board.',
  bookmarksAdd: 'Save',
  bookmarksAdded: 'Saved',
  bookmarksRemove: 'Remove from saved',
  bookmarksSignInHint: 'Sign in to save designs.',
  saved: 'Saved',
  savedCollectionDefault: 'Saved',
  follow: 'Follow',
  unfollow: 'Unfollow',
  following: 'Following',
  followers: 'Followers',
  followingTab: 'Following',
  followingEmpty: 'Follow people to see their latest designs here.',
  followersEmpty: 'No followers yet.',
  followingEmpty2: 'Not following anyone yet.',
  followSignInHint: 'Sign in to follow',
  cannotFollowSelf: "You can't follow yourself.",
  profile: 'Profile',
  profileNotFound: 'This profile does not exist.',
  profileDesigns: 'Designs',
  profileDesignsCount: 'Designs',
  profileFollowers: 'Followers',
  profileFollowing: 'Following',
  profileBio: 'Bio',
  profileEdit: 'Edit profile',
  profileMyProfile: 'My profile',
  displayNameLabel: 'Display name',
  displayNamePlaceholder: 'Your name or studio (optional)',
  displayNameSave: 'Save name',
  displayNameSaved: 'Name saved',
  displayNameErrGeneric: 'Failed to save name. Please try again.',
  handleLabel: 'Handle',
  handlePlaceholder: 'lowercase letters, digits, underscore (3-20 chars)',
  handleSave: 'Save handle',
  handleSaved: 'Handle saved',
  handleInvalid: 'Handle must be 3-20 chars: a-z, 0-9, underscore.',
  handleTaken: 'That handle is already taken.',
  handleErrGeneric: "Couldn't save the handle. Please try again.",
  bioPlaceholder: 'Say a bit about yourself (max 200 chars)',
  bioSave: 'Save bio',
  bioSaved: 'Bio saved',
  bioErrGeneric: "Couldn't save the bio. Please try again.",
  instagramLabel: 'Instagram',
  instagramPlaceholder: 'your_instagram_handle',
  instagramInvalid: 'Use only letters, digits, dot, or underscore (max 30).',
  profileNoDesigns: 'No designs yet.',
  collections: 'Collections',
  collectionsTab: 'Collections',
  collectionMine: 'My collections',
  collectionEmpty: 'No collections yet.',
  collectionPublicEmpty: 'No public collections.',
  collectionItemCount: '{n} items',
  collectionEmpty2: 'This collection is empty.',
  newCollection: 'New collection',
  collectionNamePlaceholder: 'Collection name (e.g. Living room ideas)',
  collectionCreate: 'Create',
  collectionDelete: 'Delete collection',
  collectionDeleteConfirm: 'Delete this collection? Items will be removed.',
  collectionRename: 'Rename collection',
  collectionVisibility: 'Public collection',
  collectionVisibilityOn: 'Anyone with the link can view',
  collectionVisibilityOff: 'Only you can see this collection',
  addToCollection: 'Add to collection',
  saveToCollection: 'Save to collection',
  collectionAdded: 'Added',
  collectionRemoveFromBoard: 'Remove from collection',
  collectionShareLink: 'Copy collection link',
  collectionByOwner: 'by',
  collectionNotFound: "This collection doesn't exist or is private.",
  collectionErrCreate: "Couldn't create the collection.",
  collectionErrSave: "Couldn't update the collection.",
  collectionDone: 'Done',
  collectionPickerHint: 'Tap a collection to add or remove this design.',
  uploadAcceptsHint: 'Photos work best, but sketches, elevations, floor plans, and 3D screenshots all work too.',
  examplePhotos: 'Example photos',
  detectedInputTypes: {
    sketch: 'Sketch',
    elevation: 'Elevation',
    floorplan: 'Floor plan',
    '3d_model': '3D model',
  },
  floorplanDetectedBanner: 'Looks like a floor plan — rendered the largest common-area room at eye level. To target a specific room, add a note to your additional request next time (e.g. "render the master bedroom").',
  floorplanDetectedBannerWithRoom: 'Looks like a floor plan — rendered the {room} at eye level. To target a different room, add a note to your additional request next time.',
  spaceCategoryTitle: 'What are you designing?',
  spaceCategories: {
    interior: 'Interior',
    exterior: 'Exterior',
    garden: 'Garden',
  },
  exteriorStyles: {
    halloween: { name: 'Halloween', description: 'Carved pumpkins, lanterns, moody autumn porch' },
    christmas: { name: 'Christmas', description: 'Wreaths, warm string lights, evergreen garland' },
    lunar_new_year: { name: 'Lunar New Year', description: 'Red lanterns, gold accents, auspicious couplets' },
    spring_blossom: { name: 'Spring Blossom', description: 'Blossoming trees, pastel planting, fresh light' },
    modern_facade:        { name: 'Modern Facade',         description: 'Clean geometry, large glass, mixed materials' },
    modern_farmhouse:     { name: 'Modern Farmhouse',      description: 'White siding, black trim, wood accents' },
    mediterranean:        { name: 'Mediterranean',         description: 'Stucco, terracotta, arched openings' },
    craftsman:            { name: 'Craftsman',             description: 'Wood-shingled, low-pitched gables, exposed rafters' },
    contemporary:         { name: 'Contemporary',          description: 'Sharp lines, bold volumes, industrial materials' },
    minimalist_exterior:  { name: 'Minimalist Exterior',   description: 'Restrained palette, single-material focus' },
    tudor:                { name: 'Tudor',                 description: 'English Tudor revival — half-timbered with steep gables' },
    cape_cod:             { name: 'Cape Cod',              description: 'New England traditional — white shingle with black shutters' },
    japanese_traditional: { name: 'Japanese Traditional',  description: 'Minka-style wood frame with tiled roof and engawa' },
    mountain_cabin:       { name: 'Mountain Cabin',        description: 'Timber A-frame or log cabin nestled in nature' },
    midcentury_exterior:  { name: 'Mid-Century Exterior',  description: '1950s–60s modernism — flat roof, big glass, horizontal lines' },
  },
  gardenStyles: {
    halloween: { name: 'Halloween', description: 'Pumpkin patch, lanterns, misty autumn garden' },
    christmas: { name: 'Christmas', description: 'Lit evergreens, warm lights, winter garden' },
    lunar_new_year: { name: 'Lunar New Year', description: 'Red lanterns, blossom branches, auspicious garden' },
    spring_blossom: { name: 'Spring Blossom', description: 'Cherry blossom, tulips, fresh spring green' },
    modern:         { name: 'Modern Garden', description: 'Clipped geometry, concrete pavers, architectural grasses' },
    mediterranean:  { name: 'Mediterranean', description: 'Gravel, olive and lavender, terracotta pots, pergola' },
    coastal:        { name: 'Coastal', description: 'Grasses, driftwood, salt-tolerant planting' },
    minimalist:     { name: 'Minimalist', description: 'One material, one plant palette, negative space' },
    zen:      { name: 'Zen Garden',          description: 'Raked gravel, stones, sparse plants' },
    cottage:  { name: 'Cottage Garden',      description: 'Romantic, dense planting, mixed perennials' },
    desert:   { name: 'Desert / Xeriscape',  description: 'Drought-tolerant, succulents, gravel' },
    tropical: { name: 'Tropical',            description: 'Lush foliage, big leaves, vivid blooms' },
    english:  { name: 'English Garden',      description: 'Manicured lawn, hedges, layered borders' },
  },
  seasonLabel: 'Season',
  seasons: {
    none: 'Any',
    spring: 'Spring',
    summer: 'Summer',
    autumn: 'Autumn',
    winter: 'Winter',
  },
  timeOfDayLabel: 'Time of day',
  timesOfDay: {
    none: 'Any',
    day: 'Daylight',
    golden_hour: 'Golden hour',
    night: 'Night',
  },
  editRegionReplacementLabel: 'What should change?',
  editRegionReplacementPlaceholder: 'e.g. add a large statue by the front door',
  editRegionSubmit: 'Generate edit',
  editRegionGenerating: 'Generating edited image…',
  editRegionMaskRequired: 'Brush over the area you want to change first.',
  editRegionReplacementRequired: 'Tell us what to put there.',
  editRegionBrush: 'Brush',
  editRegionUndo: 'Undo',
  editRegionSize: 'Size',
  editRegionClear: 'Reset',
  errEditGeneric: 'Edit failed. Please try again.',
  lightingPlan: 'Lighting Plan',
  designTips: 'Design Tips',
  startNew: 'Start New Design',
  viewMyDesigns: 'View My Designs',
  favorite: 'Favorite',
  unfavorite: 'Remove from favorites',
  rename: 'Rename',
  savePromptText: 'Sign in to keep this design, share it, and make more',
  guestCreditsLeft: 'Just {n} free design left. Sign in and start with {total}.',
  guestCreditsGone: 'That was your last free design. Sign in and get {total}.',
  signInGoogle: 'Sign In with Google',
  signInApple: 'Sign In with Apple',
  signInDesc: 'Save your designs and access them anytime.',
  signInPopupBlocked: 'Popup was blocked. Please allow popups in your browser settings.',

  // Header / mobile nav
  appName: 'archelier',
  navCreate: 'Create',
  navGallery: 'Gallery',
  navGio: 'Designer',
  navMain: 'Main navigation',
  packsTitle: "Top up",
  packDesigns: "about {n} designs",
  packBuying: "Opening…",
  packWaiting: "Payment done — adding your credits…",
  packDone: "Credits added.",
  packSlow: "Your credits are on the way. They'll show up shortly — no need to buy again.",
  packFailed: "The purchase didn't go through. If you were charged and no credits arrive, contact support.",
  gioRole: "Space designer",
  gioAiNote: "AI",
  gioSignInBody: "Sign in to talk with Gio. Gio looks at your room photos and your past designs, suggests styles, and can make or edit a design for you right from the chat.",
  gioGreeting: "Hi, I'm Gio. Send me a photo of your space, a picture or link of a room you love, or one of your designs — I'll suggest a direction and can make it for you.",
  gioChipTaste: "What's my taste?",
  gioChipTrend: "What's trending this week?",
  gioChipPhoto: "Send a room photo",
  gioChipMine: "Bring in one of my designs",
  gioTyping: "Gio is thinking…",
  gioPlaceholder: "Ask Gio, or paste a link",
  gioSend: "Send",
  gioAttachPhoto: "Attach photo",
  gioPickDesign: "My designs",
  gioPickEmpty: "No designs yet — make one first, then bring it here.",
  gioRemove: "Remove",
  gioToday: "Today",
  gioNoCredits: "You're out of credits.",
  gioError: "Gio couldn't answer just now. Please try again.",
  gioAlreadyStarting: "Already starting — give it a moment.",
  gioPhotoSkipped: "Some photos couldn't be added. You can attach up to {n} photos (JPG, PNG, WebP or HEIC, under 20 MB).",
  gioErrPhotos: "The photos for this one couldn't be found. Add a photo of your space and try again.",
  gioErrPrompt: "Gio couldn't turn that into a design. Try describing it a little differently.",
  gioErrGone: "That design or suggestion isn't available anymore.",
  gioCreditsLow: "{n} credits left · a message uses {c}, {p} with a photo",
  gioCreditsLowFree: "{n} credits left · chatting with Gio is free",
  gioNoCreditsChatFree: "You're out of credits for designs — chatting is still free.",
  gioDailyLimit: "That's a lot of chatting for one day. Let's pick this up tomorrow.",
  gioCardEdit: "Edit",
  gioCardPhotos: "Photos ready: {n}",
  gioCardPhotoFromDesign: "Photo from your {date} design",
  gioCardPhotoFromDesignNoDate: "Photo from one of your designs",
  gioCardPhotoFromChat: "Photo you shared here",
  gioCardPhotoNew: "New photo",
  gioCardNoPhoto: "No photo yet",
  gioCardChangePhoto: "Change",
  gioCardAddPhoto: "Add a photo",
  gioCardUploading: "Uploading…",
  gioCardSame: "You already have a {style} design from this photo ({date}).",
  gioCardSameView: "View it",
  gioCardSameHint: "With the same requests it'll come out much the same. To change it up, add specific requests above, tell Gio in the chat, or open it in Create.",
  gioPickPhoto: "Choose a photo",
  gioPickUpload: "Upload a new photo",
  gioRunEdit: "Edit · {n} credits",
  gioRunGenerate: "Make it · {n} credits",
  gioRunWithPhoto: "Add a photo & make · {n}/photo",
  gioOpenInCreate: "Open in Create",
  gioPaintMyself: "Paint the area myself",
  gioStarting: "Starting…",
  gioJobMaking: "Making your design…",
  gioJobEditing: "Editing your design…",
  gioJobNotify: "You can leave — I'll let you know when it's ready.",
  gioJobInvalid: "That photo doesn't look like a space I can design.",
  gioJobFailed: "I couldn't finish this one.",
  gioJobRefunded: "Your credits are back.",
  gioJobDone: "Ready — take a look",
  gioJobGone: "This design was deleted.",
  gioAskAboutDesign: "Ask Gio about this design",
  navFeed: 'Feed',
  navMy: 'My',
  navAccount: 'Settings',
  signIn: 'Sign In',
  signOut: 'Sign Out',
  deleteAccount: 'Delete Account',
  deleteAccountTitle: 'Delete your account?',
  deleteAccountWarn: 'This permanently deletes your account and all data linked to it. This action cannot be undone.',
  deleteAccountItem_designs: 'All your designs, images, and conversations with Gio',
  deleteAccountItem_profile: 'Your profile, handle, and saved styles',
  deleteAccountItem_social: 'Comments, likes, follows, and collections',
  deleteAccountItem_credits: 'Remaining credits, including purchased ones, and subscription history',
  deleteAccountBilling_web: 'Your active web subscription will be canceled automatically.',
  deleteAccountBilling_ios: 'Your App Store or Google Play subscription will not be canceled automatically — please cancel it in your store subscription settings.',
  deleteAccountFinal: 'You will be signed out immediately and unable to recover this account.',
  deleteAccountConfirm: 'Delete account',
  deleteAccountSubmitting: 'Deleting…',
  deleteAccountError: 'Could not delete your account. Please try again.',
  myDesigns: 'My Designs',
  language: 'Language',
  support: 'Support',
  deleteAccount: 'Delete Account',
  terms: 'Terms of Service',
  privacy: 'Privacy Policy',
  signInTerms: 'By signing in, you agree to our {terms} and {privacy}.',

  // Onboarding
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingStart: 'Get Started',
  tourTitle: 'Tour of archelier',
  tourCreate: 'Start here. Snap or upload a room, exterior or garden, pick a style, and a new design arrives moments later.',
  tourGallery: 'Gallery — the styles people picked most on archelier this week. Tap one to try it on your own space.',
  tourGio: 'Gio is your designer. Show a photo and say what you want — Gio suggests styles, then creates or edits the design for you.',
  tourMy: 'Your designs collect under My. Fix just one part by brushing over it or describing it, then download or share.',
  tourStart: "Come back to this button any time for a new design. Let's start with one photo.",
  tourReplay: 'Replay the tour',
  onboarding: [
    {
      icon: 'photo_camera',
      title: 'Snap, sketch, or upload',
      desc: 'A phone photo works best, but archelier also reads hand-drawn sketches, elevation drawings, top-down floor plans, and 3D model screenshots — all auto-detected.',
    },
    {
      icon: 'style',
      title: '19+ styles, 4 smart modes',
      desc: 'Pick a preset style, write a custom prompt, match a reference photo you love, or use Cleanup / Layout modes to tidy and rearrange the space.',
    },
    {
      icon: 'brush',
      title: 'Edit just the part you want',
      desc: 'Don\'t like one corner? Brush over it on the result and tell the AI what to put there. The rest of the room stays pixel-identical.',
    },
    {
      icon: 'auto_awesome',
      title: 'Try it right now',
      desc: 'You get free credits every day. Upload a photo and your first design is ready in about a minute.',
    },
  ],

  // Mobile spotlight onboarding — one tab at a time, short.
  onboardTabFeedTitle: 'Browse first',
  onboardTabFeedDesc: 'See what others have created and find inspiration for your own space.',
  onboardTabCreateTitle: 'Design with AI',
  onboardTabCreateDesc: 'Upload a photo, sketch, or plan — AI will generate a fresh design.',
  onboardTabMyTitle: 'Save and manage',
  onboardTabMyDesc: 'Your designs collect here. Share to the feed or download any time.',
  onboardTabGioTitle: "Ask Gio",
  onboardTabGioDesc: "Gio, our space designer, suggests styles from your photos and can make or edit designs right in the chat.",

  // My Designs page
  myDesignsTitle: 'My Designs',
  signInToSee: 'Sign in to see your designs',
  signInToSeeDesc: 'Your saved designs will appear here.',
  loadingDesigns: 'Loading designs…',
  errLoadDesigns: 'Failed to load designs. Please try again.',
  retry: 'Retry',
  noFavorites: 'No favorites yet.',
  noDesigns: 'No designs yet. Create your first one!',
  createDesign: 'Create a Design',
  loadMore: 'Load More',

  // Design detail
  loading: 'Loading…',
  errDesignNotFound: 'Design not found.',
  errLoadDesign: 'Failed to load design.',
  errDeleteDesign: 'Failed to delete. Please try again.',
  renameTitle: 'Rename Design',
  // rename 모달 placeholder — 하나만 두면 다들 그 문구를 그대로 쓴다.
  // 열 때마다 무작위로 하나 고른다 (공간 종류·버전 표기를 섞어 둬서
  // "이렇게 편하게 적으면 된다" 가 읽히게).
  renamePlaceholders: [
    'Living room redesign v1',
    'Kitchen — bright version',
    'Studio makeover',
    'Bedroom, warm tones',
    'Balcony plan B',
    'Home office setup',
    'Cafe interior draft',
    'Front yard v2',
  ],
  save: 'Save',
  cancel: 'Cancel',
  deleteTitle: 'Delete Design?',
  deleteDesc: 'This will permanently delete this design and all its images. This cannot be undone.',
  delete: 'Delete',
  deleting: 'Deleting…',
  postToFeed: 'Post to feed',
  postedToFeedTitle: 'Posted to the feed',
  postedToFeedDesc: 'Other users can now see and like this design in the feed.',
  captionTitle: 'Add a caption',
  captionPlaceholder: 'Share why you redesigned this space (optional)',
  captionEdit: 'Edit caption',
  captionPost: 'Post',
  captionSave: 'Save',
  captionCancel: 'Cancel',
  viewFeed: 'View feed',
  generationInProgress: 'Designing your space…',
  generationKeepBrowsing: 'Feel free to browse — we\'ll let you know when it\'s ready',
  generationDone: 'Your design is ready!',
  generationTapToOpen: 'Tap Open to view it',
  generationFailed: 'Generation failed',
  generationFailedHint: "Your credit wasn't charged. Please try again.",
  open: 'Open',
  tryAgain: 'Try again',
  copy: 'Copy',
  copied: 'Copied!',
  share: 'Share',
  downloadImages: 'Download AI images',
  download: 'Download',
  downloadWatermarkHint: 'A small archelier signature sits in the bottom-right corner.',
  modes: {
    redesign: 'Redesign',
    staging: 'Empty room staging',
  },
  styleUsed: 'Style Used',
  customDescLabel: 'Custom description:',
  additionalReqLabel: 'Additional requests:',
  useStyleAgain: 'Use this style again',

  // Community feed
  feedTitle: 'Community',
  feedEmpty: 'No public designs yet. Be the first!',
  feedSortLatest: 'Latest',
  feedSortPopular: 'Popular',
  feedFilterAll: 'All',
  useThisStyle: 'Try this style',
  sourceDesignBanner: 'Based on "{name}"',
  galleryPickBanner: 'Creating with {name}',
  signInToLike: 'Sign in to like designs',

  // Share view
  tryApp: 'Try archelier',
  privateTitle: 'This design is private',
  privateDesc: "The owner hasn't made this design public.",
  linkNotFoundTitle: 'This link isn\'t available',
  linkNotFoundDesc: 'The design may have been deleted, or the link is incomplete.',
  createWithApp: 'Create with archelier',
  shareViewCTA: 'Want to redesign your own space?',

  // Interior styles (display only — keywords stay in ai-service.js for AI prompts)
  styles: {
    modern:       { name: 'Modern',             description: 'Clean lines, neutral tones, minimalist contemporary' },
    scandinavian: { name: 'Scandinavian',        description: 'Bright, natural materials, cozy Nordic warmth' },
    ikea:         { name: 'IKEA',                description: 'Functional, affordable, smart Scandinavian everyday design' },
    japandi:      { name: 'Japandi',             description: 'Japanese minimalism meets Scandinavian warmth' },
    industrial:   { name: 'Industrial',          description: 'Raw materials, exposed elements, urban loft aesthetic' },
    coastal:      { name: 'Coastal',             description: 'Breezy, light-filled beach house elegance' },
    classic:      { name: 'Classic',             description: 'Timeless elegance, rich fabrics, ornate details' },
    artdeco:      { name: 'Art Deco',            description: 'Bold geometry, gold accents, glamorous 1920s opulence' },
    midcentury:   { name: 'Mid-Century Modern',  description: 'Organic shapes, warm wood, 1950–60s retro-modern charm' },
    maximalist:   { name: 'Maximalist',          description: 'Bold patterns, rich layers, more-is-more philosophy' },
    vintage:      { name: 'Vintage',             description: 'Nostalgic charm, antique finds, warm retro palette' },
    bohemian:     { name: 'Bohemian',            description: 'Free-spirited, colorful textiles, artistic eclecticism' },
    tropical:     { name: 'Tropical',            description: 'Lush greenery, rattan, breezy resort feel' },
    cottagecore:  { name: 'Cottagecore',         description: 'Romantic English countryside, florals, soft pastels' },
    rustic:       { name: 'Rustic',              description: 'Weathered wood, stone, warm farmhouse charm' },
    wabisabi:     { name: 'Wabi-Sabi',           description: 'Imperfect beauty, raw textures, quiet Japanese asceticism' },
    gothic:       { name: 'Gothic',              description: 'Moody dark drama, velvet, ornate silhouettes' },
    cyberpunk:    { name: 'Cyberpunk',           description: 'Neon-lit futurism, hi-tech surfaces, urban dystopia' },
    taisho_romance: { name: 'Taisho Romance',    description: 'Early 20th-century Japan meets Western Art Nouveau' },
    biophilic:    { name: 'Biophilic',           description: 'Plants everywhere, natural light, organic textures' },
    cozy:         { name: 'Cozy',                description: 'Warm, soft, inviting — hygge-style comfort' },
    gaming:       { name: 'Gaming',              description: 'RGB-lit setup, sleek tech, immersive battlestation' },
    minimalist:     { name: 'Minimalist', description: 'Pared back, low clutter, negative space' },
    mediterranean:  { name: 'Mediterranean', description: 'Limewash walls, terracotta, arches, natural stone' },
    luxury:         { name: 'Quiet Luxury', description: 'Fine materials, restrained palette, nothing loud' },
    dark_academia:  { name: 'Dark Academia', description: 'Moody library — oxblood, brass, stacked books' },
    organic_modern: { name: 'Organic Modern', description: 'Modern forms in raw natural material' },
    farmhouse:      { name: 'Farmhouse', description: 'Shiplap, apron sink, weathered wood, warm country' },
    halloween:      { name: 'Halloween', description: 'Pumpkins, candles, moody autumn dark' },
    christmas:      { name: 'Christmas', description: 'Tree, garlands, warm lights, festive layering' },
    lunar_new_year: { name: 'Lunar New Year', description: 'Red and gold, lanterns, auspicious motifs' },
    spring_blossom: { name: 'Spring Blossom', description: 'Cherry blossom, pastels, fresh airy light' },
    custom:       { name: 'Custom Style',        description: 'Describe your own unique interior vision' },
    reference:    { name: 'Reference',           description: 'Match the tone, materials, and mood of a photo you upload' },
    floorplan:    { name: 'Floor plan', description: 'A 3D plan or a clean drawing from your floor plan' },
    cleanup:      { name: 'Cleanup',              description: 'Tidy up clutter or empty the room — your choice' },
    layout:       { name: 'Layout',              description: 'Same furniture, smarter placement — flow or spacious' },
  },

  langMismatchNotice: 'This analysis was generated in {lang}.',

  // Pricing page
  pricingTitle: 'Plans that scale with you',
  pricingSubtitle: 'Start free. Upgrade when you need more generations and premium features.',
  pricePerMonth: '/ month',
  trialCta: 'Start {n}-day free trial',
  accountPlanFreeTitle: 'Your account is FREE',
  accountPlanProTitle: "You're on Pro",
  accountPlanTrialTitle: "You're on Pro — Free Trial",
  proTrialBadge: 'Trial',
  proTrialDaysLeft: '{n} days left in your free trial',
  proTrialIntroTitle: 'Get 2 weeks of Pro — free',
  proTrialIntroDesc: 'Sign up and start with {n} free credits.',
  proTrialFeatures: 'Then {n} more free every day. No subscription, ever.',
  welcomeSkip: 'Continue without an account',
  // Marketing landing (/landing)
  landingHeadline: 'redesign any room, in seconds.',
  landingTagline: 'Snap a photo, pick a style, get a photoreal interior render. Free every day, no subscription.',
  landingOpenWeb: 'Or continue on the web →',
  landingFeat1: 'AI interior renders',
  landingFeat2: 'Photoreal',
  landingFeat3: '50+ styles',
  landingFeat4: 'Garden & exterior',
  landingFeat5: 'Free every day',
  landingStoreOn: 'Download on the',
  landingStoreGet: 'Get it on',
  // Landing sections (lp.*) — 웹 랜딩 본문이자 언어별 정적 페이지(/ko, /ja …)·JSON-LD 의 원본.
  // 크레딧 지급량·가격 숫자는 쓰지 않는다 (config/credits 로 바뀐다). 스타일 수는 store-metadata.md 표와 맞출 것.
  lp: {
    metaTitle: 'archelier — AI Interior Design from a Photo, Sketch, or Floor Plan',
    metaDescription: 'Snap a photo of any room and get a photoreal redesign in about a minute. 48 styles for interiors, exteriors, and gardens, 3D floor plans, brush edits, and an AI designer to chat with. Free every day.',
    heroEyebrow: 'AI interior design',
    scrollCue: 'See how it works',
    webCta: 'Try it free in your browser',
    orApp: 'Or get the app',
    qrHint: 'Scan with your phone camera. The app lets you know the moment your design is ready.',
    showEyebrow: 'Before & after',
    showTitle: 'One photo. A whole new room.',
    showBody: 'Real results, made with archelier. Drag to compare.',
    before: 'Before',
    after: 'After',
    tabRoom: 'Living room',
    tabEmpty: 'Empty room',
    tabSketch: 'Sketch',
    tabPlan: 'Floor plan',
    tabExterior: 'Exterior',
    capRoom: 'Rustic — the same kitchen and living room, made warmer.',
    capEmpty: 'Scandinavian — an empty room, furnished.',
    capSketch: 'Japandi — a line sketch, rendered as a real space.',
    capPlan: 'Floor plan mode — a 2D plan, turned into a 3D view of the whole home.',
    capExterior: 'Minimalist — a busy storefront, redesigned.',
    howEyebrow: 'How it works',
    howTitle: 'Three steps, about a minute.',
    how1Title: 'Take a photo',
    how1Body: 'Any room, just as it is — or a sketch, a floor plan, or a 3D screenshot. Up to 3 angles of the same room.',
    how2Title: 'Pick a style',
    how2Body: 'Choose one of 48 styles, describe your own in a sentence, or upload a photo whose look you love.',
    how3Title: 'Get your design',
    how3Body: 'A photoreal render of your space, with a furniture list, color palette, and lighting plan.',
    stylesEyebrow: 'Styles',
    stylesTitle: '48 styles, three kinds of space.',
    stylesBody: '28 for interiors, 11 for exteriors, 9 for gardens — plus seasonal looks for Halloween, Christmas, Lunar New Year, and spring.',
    stylesInterior: 'Interior',
    stylesExterior: 'Exterior',
    stylesGarden: 'Garden',
    stylesCta: 'Browse the style gallery',
    modesEyebrow: 'Beyond styles',
    modesTitle: 'Five more ways to work on a space.',
    modeCustomTitle: 'Custom style',
    modeCustomBody: 'Describe the look in a sentence and save it for next time.',
    modeReferenceTitle: 'Reference',
    modeReferenceBody: 'Upload a photo you love and borrow its tone, materials, and palette — not its layout.',
    modeCleanupTitle: 'Cleanup',
    modeCleanupBody: 'Clear the clutter and see the room bare.',
    modeLayoutTitle: 'Layout',
    modeLayoutBody: 'Rearrange the furniture that is already there instead of replacing it.',
    modePlanTitle: 'Floor plan',
    modePlanBody: 'Turn a floor plan into a 3D view of the whole home, or a rough sketch into a clean drawing.',
    editEyebrow: 'Brush editing',
    editTitle: 'Change one thing at a time.',
    editBody: 'Not happy with just the sofa? Circle it and type what you want instead. archelier repaints only that area and leaves the rest of the room untouched — the same goes for wall color, rugs, lighting, and art.',
    editPrompt: 'A vintage leather sofa',
    shopTitle: 'Shop what you see.',
    shopBody: 'Every design comes with a furniture list, color palette, and lighting plan, and each piece links to a search for ones that look like it.',
    gioEyebrow: 'Gio',
    gioTitle: 'Talk it through with a designer.',
    gioBody: 'Gio is your AI space designer, in a tab of its own. Send a photo of your room, a picture or link of a space you love, or one of your designs. Gio suggests a direction and makes or edits the design for you, right in the chat.',
    gioRole: 'Space designer',
    gioUser: 'This is my kitchen and dining area. It feels a bit cold. Any ideas?',
    gioReply: 'Let’s layer warm wood, soft textiles, and low ambient light instead of stark surfaces. Here’s a direction to try:',
    gioCardTitle: 'Japandi warmth',
    gioCardBody: 'Natural oak and textured plaster bring warmth to the space right away.',
    gioCardAction: 'Make it',
    priceEyebrow: 'Pricing',
    priceTitle: 'Free every day. No subscription.',
    price1: 'Free designs every day, refreshed at your local midnight',
    price2: 'A bonus when you create an account',
    price3: 'Invite a friend and you both get more',
    price4: 'Need more? Top up with a credit pack',
    privacyTitle: 'Your photos stay yours.',
    privacyBody: 'Your photos, prompts, and designs are never used to train AI models or for advertising. Your designs stay private unless you share them.',
    faqTitle: 'Questions',
    faq1Q: 'What is archelier?',
    faq1A: 'archelier (Architect + Atelier) is an AI interior design app for your phone and the web. Point your camera at a room, pick a style, and get back a photoreal redesign of that exact space, with every piece of furniture named and linked. It works for interiors, exteriors, and gardens.',
    faq2Q: 'How does it work?',
    faq2A: 'Take a photo of the room, or upload a sketch, a floor plan, or a 3D screenshot. Pick one of 48 styles, describe your own, or upload a reference photo. In about a minute you get a photoreal render of your space, plus a furniture list, color palette, and lighting plan.',
    faq3Q: 'Is archelier free?',
    faq3A: 'Yes. There is no subscription. Everyone gets free designs every day, refreshed at local midnight, plus a bonus for creating an account and for inviting a friend. If you want more, you can buy a credit pack.',
    faq4Q: 'Can it turn a floor plan into a 3D rendering?',
    faq4A: 'Yes. Floor plan mode turns a 2D floor plan into a 3D view of the whole home in the style you pick. It can also turn a hand sketch or a blurry plan into a clean drawing or a colored plan.',
    faq5Q: 'Can I match the style of a photo I love?',
    faq5A: 'Yes. Choose the Reference style and upload the inspiration photo. archelier borrows its tone, materials, and palette and applies them to your room without copying its layout.',
    faq6Q: 'Can I change just one part of a design?',
    faq6A: 'Yes. Circle the area you want to change — the sofa, the rug, a wall — and type what you want instead. Only that area is repainted; the rest of the room stays as it was.',
    faq7Q: 'What is Gio?',
    faq7A: 'Gio is archelier’s AI space designer. Send it a photo of your room, a picture or link of a space you love, or one of your designs. Gio suggests a direction, makes or edits the design for you in the chat, and answers questions about color, budget, and lighting.',
    faq8Q: 'Are my photos used to train AI?',
    faq8A: 'No. archelier does not use your photos, prompts, or designs to train AI models or for advertising. Your designs stay private to your account unless you share them.',
    faq9Q: 'Where can I use archelier?',
    faq9A: 'On the App Store, on Google Play, and on the web at archelier.co. Your account and designs stay in sync everywhere. archelier is available in 11 languages.',
    ctaTitle: 'Redesign your room today.',
    ctaBody: 'On your phone and on the web. Your designs stay in sync everywhere.',
    langLabel: 'Language',
  },
  upgradeToPro: 'Upgrade to Pro',
  creditsPerMonth: '{n} credits per month',
  planFreeName: 'Free',
  planFreeTagline: 'Try archelier with a few designs every month.',
  planProName: 'Pro',
  planProTagline: 'For regular designers who want quality results.',
  planStudioName: 'Studio',
  planStudioTagline: 'For power users, teams, and commercial work.',
  planFeatWatermark: 'Includes "archelier" watermark',
  planFeatNoWatermark: 'No watermark on saved or shared designs',
  planFeatUnlimited: 'Unlimited AI design generations',
  planFeatUnlimitedChat: 'Unlimited AI chat per design (free: 3 turns)',
  planFeatUnlimitedEdit: 'Unlimited region edits',
  planFeatFeed: 'Share to the feed',
  planFeatEverythingPro: 'Everything in Pro',
  planFeatCommercial: 'Commercial usage rights',
  planFeatApiAccess: 'API access (coming soon)',
  planCtaSubscribe: 'Subscribe',
  planCtaCurrent: 'Your current plan',
  planPopular: 'Most popular',
  signInToSubscribe: 'Sign in to subscribe',
  signInToBuy: 'Sign in to purchase',
  trialNote: '{n}-day free trial',

  creditPacksTitle: 'Or top up with credit packs',
  creditPacksSubtitle: 'One-time purchase, no subscription required.',
  packStarterName: 'Starter Pack',
  packStandardName: 'Standard Pack',
  packProName: 'Pro Pack',
  packCreditsAmount: '{n} credits',
  packCtaBuy: 'Purchase',
  pricingFootnote: 'Prices shown in USD. Taxes calculated at checkout. Cancel anytime.',
  errBillingGeneric: 'Something went wrong processing your request. Please try again.',

  // Account page
  accountTitle: 'Settings',
  accountPlanSection: 'Subscription',
  accountCreditsSection: 'Credits',
  accountCreditsDesc: 'Credits are consumed when generating designs. Top up any time.',
  viewPlans: 'View plans',
  changePlan: 'Change plan',
  manageBilling: 'Manage billing',
  manageBillingWebHint: 'If you subscribed on the web, you can manage it on archelier.co.',
  buyCreditPack: 'Buy credit pack',
  subRenewsAt: 'Renews on {date}',
  subEndsAt: 'Ends on {date}',
  trialEndsAt: 'Free trial ends on {date} — auto-converts to $9.99/mo',
  trialCancelEndsAt: 'Trial ends on {date} — subscription will not renew',
  subStatus_past_due: 'Payment past due — please update your payment method.',
  subStatus_canceled: 'Subscription cancelled.',
  subStatus_unpaid: 'Subscription unpaid.',
  subStatus_trialing: 'Free trial active.',
  account: 'Account',
  pricing: 'Pricing',
  upgrade: 'Upgrade',

  // Invite / promo page
  inviteTitle: 'Invite friends & earn credits',
  inviteSubtitle: 'When a friend signs up with your link, you get +{inviter} credits and they get +{invitee}.',
  inviteFriends: 'Invite friends',
  inviteSignInHint: 'Sign in to get your personal invite link.',
  yourReferralCode: 'Your invite link',
  inviteCodeLoading: 'Preparing your invite link…',
  inviteLinkHint: 'New signups through your link get +{n} starter credits.',
  copyLink: 'Copy link',
  shareLink: 'Share link',
  inviteShareText: 'Redesign your space with AI on archelier. Use my link to get +{n} free credits.',
  redeemTitle: 'Have a code?',
  redeemDesc: 'Enter an invite code from a friend, or a promo code, to get bonus credits.',
  copyCode: 'Copy code',
  errRefSelf: "You can't use your own invite code.",
  landingInviteTitle: 'A friend invited you — you both get +{n} credits.',
  landingInviteAutoIos: "Install the app, then tap this invite link again — the app opens, and your bonus is added when you sign up.",
  landingInviteAutoAndroid: "Install with the Google Play button below and sign up — your bonus is added automatically. If it isn't, enter this code under Settings → Invite friends.",
  landingInviteDesktop: "Sign up here and your bonus is added right away. To get it in the phone app, scan the QR code and follow the steps on your phone.",
  promoTitle: 'Got a promo code?',
  promoDesc: 'Enter a promo code to redeem bonus credits.',
  promoPlaceholder: 'e.g. LAUNCH2026',
  promoRedeem: 'Redeem',
  promoSuccess: 'Redeemed — {n} credits added to your account.',
  errPromoInvalid: 'That code is invalid.',
  errPromoExpired: 'This code has expired.',
  errPromoMaxed: 'This code has reached its usage limit.',
  errPromoUsed: "You've already redeemed this code.",
  errPromoUserInit: 'Please reload and try again.',
  errPromoGeneric: "Couldn't redeem that code. Please try again.",

  // Reports / moderation (Phase 8-4)
  reportThisDesign: 'Report this design',
  reportShort: 'Report',
  reportTitle: 'Report design',
  reportDesc: "What's wrong with this design? Only moderators see your report.",
  reportReason_spam: 'Spam or advertising',
  reportReason_nsfw: 'Sexual or inappropriate content',
  reportReason_copyright: 'Copyright infringement',
  reportReason_other: 'Other',
  reportNotePlaceholder: 'Add details (optional, up to 500 chars)',
  reportSubmit: 'Submit report',
  reportSubmitting: 'Submitting…',
  reportSignInHint: 'Please sign in to submit a report.',
  reportThanks: 'Report received',
  reportThanksDesc: "We'll take a look and act if needed. Thanks for flagging it.",
  errReportGeneric: "Couldn't submit the report. Please try again in a moment.",

  // Blocking (App Review Guideline 1.2)
  blockUser: 'Block this user',
  unblockUser: 'Unblock',
  blockShort: 'Block',
  blockConfirm: "Block @{handle}? You won't see their designs or activity, and they can't interact with yours.",
  blockedUsersMenu: 'Blocked users',
  blockedUsersTitle: 'Blocked users',
  blockedUsersDesc: "Users you've blocked. Their designs are hidden from your feed and profiles.",
  blockedUsersEmpty: "You haven't blocked anyone.",
  profileBlocked: 'You have blocked this user.',
  profileBlockedAction: 'Unblock to see their designs again.',
  errBlockGeneric: "Couldn't update block status. Please try again.",
  errBlockedCustomCommand: 'Your request contains words that are not allowed.',
  moderationAutoUnlisted: 'This design was automatically removed from the public feed by our moderation check. If you believe this is a mistake, please contact the admins.',

  // Language name used in AI prompt
  promptLang: 'English',
};
